<template>
  <info-dialog-template
    v-model="isShownDialog"
    :title="$t('safe.deal.refund.processing.title')"
    @click="handleClose"
  >
    <div :class="$style.container">
      <p>{{ $t('safe.deal.refund.processing.description') }}</p>
      <p v-html="displayPayoutNotAvailable"></p>
    </div>
  </info-dialog-template>
</template>

<script>
import dialogMixin from 'lib/mixins/dialogMixin';
import InfoDialogTemplate from 'templates/InfoDialogTemplate';

export default {
  name: 'SafeDealRefundProcessingStatusDialog',
  mixins: [
    dialogMixin,
  ],
  components: {
    InfoDialogTemplate,
  },
  computed: {
    displayPayoutNotAvailable() {
      return this.$t('safe.deal.payout.not.available', {
        startTag: '<span style="color: var(--color-red)">',
        endTag: '</span>',
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff

    p
      opacity: .75

      &:not(:last-child)
        margin-bottom: 20px
</style>
